import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  AbcPopupComponent,
  _AbcButtonComponent,
  _AbcFileUploaderComponent,
  _AbcTextAreaComponent,
} from '@barthauer/abc/ui-components';
import { DocumentKind, GeoDsDocument, NotificationMessage, Task, ToastType } from '@barthauer/custom/xmt-models';
import { FlexLayoutModule } from 'ngx-flexible-layout';
import { forkJoin, of, Subscription } from 'rxjs';
import { finalize, first, map, switchMap } from 'rxjs/operators';

import { AppService } from '../../services/app.service';
import { DataService, ObjectKeys } from '../../services/data.service';
import { NotificationService } from '../../services/notification.service';
import { StyleService } from '../../services/style.sevice';
import { UploadService } from '../../services/upload.service';
import { Person, SupportTicket, SupportType } from './support-mail.model';
import { SupportMailService } from './support-mail.service';
import { HttpClient } from '@angular/common/http';
import { CustomDataService } from '@barthauer/custom/arena';
import { ConvertHelper } from '@barthauer/abc/core';
import { DataService as CoreDataService, Query, QueryColumn, QueryObjectsModel } from '@barthauer/abc/core/data';
import { UserService } from '@barthauer/aptis-authentication';
export class UserPersonInfo {
  Id: string;
  FullName: string;
  FirstName: string;
  LastName: string;
  ParentId: string;
  Company: string;
  ImgPortrait: string;
}
@Component({
    selector: 'support-mail-popup',
    providers: [StyleService, SupportMailService],
    imports: [
        CommonModule,
        AbcPopupComponent,
        FlexLayoutModule,
        _AbcButtonComponent,
        _AbcTextAreaComponent,
        _AbcFileUploaderComponent,
    ],
    templateUrl: './support-mail-popup.component.html',
    styleUrls: ['./support-mail-popup.component.scss']
})
export class SupportPopupComponent implements OnInit, OnDestroy {
  @ViewChild('supportPopup', { static: false }) supportPopup: AbcPopupComponent;
  @ViewChild('imagesUploader', { static: false }) imagesUploader: _AbcFileUploaderComponent;

  public showLoaderSupportPopup: boolean = false;
  public supportType: SupportType;
  private primary_gray_color = '#7e7e7e';
  private secondary_gray_color = '#eaebec';
  public description: string = '';
  public uploadImages: GeoDsDocument = new GeoDsDocument(null);
  public imagesToUpload: GeoDsDocument[] = [];
  private subscriptions: Subscription[] = [];
  public personDetails = new Person(null);
  constructor(
    private styleService: StyleService,
    private uploadService: UploadService,
    private supportService: SupportMailService,
    private appService: AppService,
    public dataService: DataService,
    public dataSericeArena: CustomDataService,
    private notificationService: NotificationService,
    private http: HttpClient,
    private coreDataService: CoreDataService,
    private userService: UserService

  ) { }

  ngOnInit(): void {
    this.uploadService.uploadMultipleData$.subscribe((uploadData: GeoDsDocument) => {
      uploadData.Kind = DocumentKind.Bild;
      uploadData.ParentObjectType = ObjectKeys.DOCUMENT;
      this.imagesToUpload.push(uploadData);
    });
    this.getProfilInformation()
  }

  public async getProfilInformation() {
    const userInformations = await this.dataSericeArena.getUserInformations();
    this.personDetails.Company = userInformations.person.CompanyName;
    this.personDetails.FullName = userInformations.person.FullName;
    this.personDetails.EMail = userInformations.person.EMail;
  }
  public show() {
    this.supportPopup.instance.show();
  }


  public onHiding() {
    this.reset();
  }
  public get supportTypes(): typeof SupportType {
    return SupportType;
  }

  public onImageUpload(event, document): void {
    this.uploadService.onFileChanged(event, document);
  }

  public isSendEnabled(): boolean {
    return this.description === '' || this.showLoaderSupportPopup;
  }
  public onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.supportService.handleImageUpload(input.files);
    }
  }

  public sendSupportTicket(): void {
    this.showLoaderSupportPopup = true;
    if (!this.personDetails.EMail) {
      this.notificationService.callNotification({ message: this.dataService.res("Ubt-User-Mail-Empty"), type: ToastType.ERROR })
      this.showLoaderSupportPopup = false;
      this.supportPopup.instance.hide();

    }
    else {
      this.subscriptions.push(
        this.supportService
          .prepareProfileCompany()
          .pipe(
            switchMap((_company: any) => {
              if (Array.isArray(_company) && _company.length > 0) {
                const supportTicket: SupportTicket = new SupportTicket({
                  SupportType: this.supportType,
                  Subject: this.supportType + _company[0].Name + ' - ' + this.personDetails.EMail,
                  Description: this.description,
                  Attachments: this.imagesToUpload,
                });

                const task = this.generateTask(supportTicket, _company[0].Id);

                return this.supportService.persisteTask(task).pipe(
                  switchMap((_newTask: any) => {
                    this.imagesToUpload.forEach((_img) => {
                      _img.ParentId = _newTask.Id;
                    });
                    if (this.imagesToUpload.length > 0) {
                      return forkJoin([
                        this.uploadService.persistUploadFiles(this.imagesToUpload),
                        this.supportService.sendEmail(this.personDetails, this.description)
                      ]).pipe(
                        map((_uploadedFiles) => ([
                          _company,
                          _newTask,
                          _uploadedFiles,
                        ]))
                      );
                    } else {
                      return this.supportService.sendEmail(this.personDetails, this.description).pipe(switchMap((_uploadedFiles: any) => {
                        return of([_company, _newTask, _uploadedFiles]);
                      }
                      ))
                    }
                  })
                )

              }
            }),
            first(),
            finalize(() => {
              this.showLoaderSupportPopup = false;
              this.supportPopup.instance.hide();
              this.reset();
            })
          )
          .subscribe(
            ([_company, _newTask, _uploadedFiles]) => {
              this.notificationService.callNotification({
                message: NotificationMessage.ValidInsertMessage,
                type: ToastType.SUCCESS,
              });
            },
            (error) => {
              this.notificationService.callNotification({
                message: NotificationMessage.Error,
                type: ToastType.ERROR,
              });
            }
          )
      );
    }
  }

  private generateTask(supportTicket: SupportTicket, parentId: string): Task {
    const currentDay = new Date();

    const task = new Task({
      ParentId: parentId,
      ParentObjectType: ObjectKeys.ADDRESS,
      Body: supportTicket.Description,
      Kind: 'EML',
      NetmeetingType: supportTicket.SupportType === SupportType.legal ? 'LegalSupport' : 'TechnicalSupport',
      StartDate: currentDay,
      StartTime: currentDay,
      Subject: supportTicket.Subject,
      Type: 0,
    });

    return task;
  }

  private reset() {
    this.supportType = undefined;

    const technicalEl = document.getElementById(SupportType.technical);
    if (technicalEl) {
      technicalEl.style.color = this.primary_gray_color;
      technicalEl.style.backgroundColor = this.secondary_gray_color;
    }

    const legalEl = document.getElementById(SupportType.legal);
    if (legalEl) {
      legalEl.style.color = this.primary_gray_color;
      legalEl.style.backgroundColor = this.secondary_gray_color;
    }
    this.description = '';

    this.imagesUploader.instance.reset();

    this.uploadImages = new GeoDsDocument(null);
    this.imagesToUpload = [];
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
